<template>
  <fb-form-body>
    <el-form :model="formData" ref="form" label-width="auto">

      <el-form-item class="form-item" :label="$t('lang.轮播图名称')" required>
        <el-input v-model="formData.name" :placeholder="$t('lang.轮播图名称')" />
      </el-form-item>

      <el-form-item class="form-item" :label="$t('lang.标识')" required>
        <el-select v-model="formData.flag">
          <el-option :label="$t('lang.APP首页')" value="APP_HOME" />
          <el-option :label="$t('lang.设备菜谱首页')" value="RECIPE_HOME" />
        </el-select>
      </el-form-item>

      <el-form-item class="form-item" label="pid" required>
        <el-input v-model="formData.pid" placeholder="pid" />
      </el-form-item>

      <el-form-item :label="$t('lang.主语言') + '：'" required>
        <el-radio-group v-model="formData.lang" style="min-width: 800px">
          <el-row :gutter="24">
            <el-col :span="6" v-for="lang in langList" :key="lang.value + '_key'">
              <el-radio :label="lang.value">{{ lang.name }}（{{ lang.value }}）</el-radio>
            </el-col>
          </el-row>
        </el-radio-group>
      </el-form-item>

      <el-form-item :label="$t('lang.轮播图')" required>
        <banner-table ref="bannerTable" />
        <span style="font-size: 13px; color: red">{{$t('lang.必须选择多语言的食谱')}}</span>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="handleSubmit('form')">{{ $t('lang.确定') }}</el-button>
        <el-button @click="handleReset()">{{ $t('lang.重置') }}</el-button>
      </el-form-item>
    </el-form>
  </fb-form-body>
</template>

<script>
import BannerTable from "../../components/banner/BannerTable";
import {handleFilterLang} from "../../utlis/utlis";
export default {
  name: "BannerEdit",
  components: {BannerTable},
  data() {
    return {
      api: {
        update: this.$api.banner.update,
        detail: this.$api.banner.detail,
      },
      formData: {
        name: "",
        brandOwnerCode: "",
        flag: "",
        code: "",
        lang: "",
        pid: "",
      },
    }

  },
  methods: {
    handleSubmit() {
      if(!this.formData.lang) {
        this.$message.error("请选择语言");
        return;
      }
      let bannerData = this.$refs.bannerTable.getData();
      let items = bannerData.map(item => {
        item.lang = this.formData.lang;
        item.title = item.langs.find(f => f.lang === item.lang).title;
        return item;
      });

      let params = {
        items,
        ...this.formData,
      };
      // delete params.lang;
      this.$http.post(this.api.update, params).then(res => {
        if(res.data.status != 200) {
          this.$message.error(res.data.desc);
          return;
        }
        this.$message.success(res.data.desc);
        this.$router.back();
      })

    },
    // 重置
    handleReset() {
      this.$refs.bannerTable.reset();
      for (const key in this.formData) {
        this.formData[key] = "";
      }
    },
    // 加载详情
    handleLoadDetail() {
      this.$http.post(this.api.detail, this.$qs.stringify(this.$route.query)).then(res => {
        if(res.data.status != 200) {
          this.$message.error(res.data.desc);
          return;
        }
        let data = res.data.data.ccBanner;
        for (const key in this.formData) {
          this.formData[key] = data[key];
        }
        this.$nextTick(() => {
          this.$refs.bannerTable.setData(data.items);
        })
      })
    },
  },
  computed: {
    langList() {
      let list = handleFilterLang(this);
      return list || [];
    }
  },
  created() {
    this.handleLoadDetail();
  },
  beforeRouteLeave(to, from, next) {
    if(to.name === "banner-recipe") {
      this.$store.commit("CHANGE_KEEP_ALIVE_INCLUDE", {type: "add", value: "BannerEdit"})
    } else {
      this.$store.commit("CHANGE_KEEP_ALIVE_INCLUDE", {type: "remove", value: "BannerEdit"})
    }
    next();
  }
}
</script>

<style scoped>
.form-item {
  width: 500px;
}

.el-select {
  width: 100%;
}



/deep/ .el-radio {
  line-height: 40px;
}


</style>
